import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';
import { useAuth } from '../../Provider/AuthProvider';

const ProfileDropdown = () => {
    const { user } = useAuth();

    const [isProfileDropdown, setIsProfileDropdown] = useState(false);
    const toggleProfileDropdown = () => {
        setIsProfileDropdown(!isProfileDropdown);
    };

    const firstInitial = user?.userinfo?.firstname?.charAt(0)?.toUpperCase() || '?';

    return (
        <Dropdown isOpen={isProfileDropdown} toggle={toggleProfileDropdown} className="ms-sm-3 header-item topbar-user">
            <DropdownToggle tag="button" type="button" className="btn">
                <span className="d-flex align-items-center">
                    <span className="avatar-sm rounded-circle bg-primary text-white d-flex justify-content-center align-items-center" style={{ width: '36px', height: '36px', fontSize: '16px' }}>
                        {firstInitial}
                    </span>
                    <span className="text-start ms-xl-2">
                        <span className="d-none d-xl-inline-block ms-1 fw-medium user-name-text">{user.userinfo.firstname}</span>
                    </span>
                </span>
            </DropdownToggle>
            <DropdownMenu className="dropdown-menu-end">
                <h6 className="dropdown-header">Bienvenue {user.userinfo.firstname}!</h6>

                {/*<DropdownItem className='p-0'>*/}
                {/*    <Link to="/profile" className="dropdown-item">*/}
                {/*        <i className="mdi mdi-account-circle text-muted fs-16 align-middle me-1"></i>*/}
                {/*        <span className="align-middle">Profil</span>*/}
                {/*    </Link>*/}
                {/*</DropdownItem>*/}

                <DropdownItem className='p-0'>
                    <Link to="/logout" className="dropdown-item">
                        <i className="mdi mdi-logout text-muted fs-16 align-middle me-1"></i>
                        <span className="align-middle">Se déconnecter</span>
                    </Link>
                </DropdownItem>
            </DropdownMenu>
        </Dropdown>
    );
};

export default ProfileDropdown;
